namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoHd1Row {
        Id?: number;
        PromoCampaign?: string;
        PromoCampName?: string;
        PmGroupId?: string;
        PmGroupDesc?: string;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PromoTimeFg?: PromoTimeFg;
        StartPromoTime?: string;
        EndPromoTime?: string;
        PromoDayFg?: PromoDayChFg;
        PromoDay?: number[];
        PromoShopFg?: PromoShopFg;
        PromoShop?: string[];
        PromoCustFg?: number;
        PromoMb?: string[];
        PromoApproveFg?: number;
        PromoStatus?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
        ApproveBy?: string;
        Approvedate?: string;
        ActiveBy?: string;
        Activedate?: string;
        ItemList?: PsAdvPromoItemRow[];
        ItemExList?: PsAdvPromoItemExemptRow[];
        VenderSharing?: number;
    }

    export namespace PsAdvPromoHd1Row {
        export const idProperty = 'PmGroupId';
        export const nameProperty = 'PmGroupId';
        export const localTextPrefix = 'AdvPromo.PsAdvPromoHd1';
        export const lookupKey = 'AdvPromo.PsAdvPromoHd1';

        export function getLookup(): Q.Lookup<PsAdvPromoHd1Row> {
            return Q.getLookup<PsAdvPromoHd1Row>('AdvPromo.PsAdvPromoHd1');
        }
        export const deletePermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:Delete';
        export const insertPermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:Modify';
        export const readPermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:View';
        export const updatePermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:Modify';

        export declare const enum Fields {
            Id = "Id",
            PromoCampaign = "PromoCampaign",
            PromoCampName = "PromoCampName",
            PmGroupId = "PmGroupId",
            PmGroupDesc = "PmGroupDesc",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PromoTimeFg = "PromoTimeFg",
            StartPromoTime = "StartPromoTime",
            EndPromoTime = "EndPromoTime",
            PromoDayFg = "PromoDayFg",
            PromoDay = "PromoDay",
            PromoShopFg = "PromoShopFg",
            PromoShop = "PromoShop",
            PromoCustFg = "PromoCustFg",
            PromoMb = "PromoMb",
            PromoApproveFg = "PromoApproveFg",
            PromoStatus = "PromoStatus",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate",
            ApproveBy = "ApproveBy",
            Approvedate = "Approvedate",
            ActiveBy = "ActiveBy",
            Activedate = "Activedate",
            ItemList = "ItemList",
            ItemExList = "ItemExList",
            VenderSharing = "VenderSharing"
        }
    }
}
